import { render, staticRenderFns } from "./WebUserSignupDialog.vue?vue&type=template&id=c6dd4538&lang=pug&"
import script from "./WebUserSignupDialog.vue?vue&type=script&lang=ts&"
export * from "./WebUserSignupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports